export default __webpack_public_path__ + "static/plane-d33e65516d8702b821c42d7763b74c9a.png";